import styled from "styled-components";

export const LinkHoverLine = styled.div`
    display: none;
    height: .025rem;

    opacity: 50%;
`